import React from "react";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";
import { Link } from "react-router-dom";
import { IntercomConversationApi, OrganizationPartnerInfoApi } from "../../../../../../services/Api/Admin/adminTypes";
import { OrganizationApi, OrganizationProductPerCategoryApi, UserRole } from "../../../../../../services/Api/types";
import { OrganizationPreviewRequests } from "../services/types";
import OrganizationPreviewRoutes from "./OrganizationPreviewRoutes";

interface Props {
	getCardTypes: () => string[];
	url: string;
	areAllowed: (contexts: Record<string, UserRole[]>) => boolean;
	requests: OrganizationPreviewRequests;
	organization: OrganizationApi;
	refresh: () => Promise<void>;
	partners: OrganizationPartnerInfoApi[];
	conversations: IntercomConversationApi[];
	loading: boolean;
	products: OrganizationProductPerCategoryApi[];
	loadingProducts: boolean;
	context: string;
}

const OrganizationPreviewTabNavigation = ({
	getCardTypes,
	url,
	organization,
	refresh,
	requests,
	loading,
	partners,
	conversations,
	areAllowed,
	loadingProducts,
	products,
	context,
}: Props) => {
	const location = useLocation();
	const { t } = useTranslation("admin");

	const getLastPathnamePart = () => {
		const splittedPathname = location?.pathname?.split("/");
		return splittedPathname[splittedPathname.length - 1];
	};
	const isApplicationsView = () => {
		const lastPathnamePart = getLastPathnamePart();
		return (
			lastPathnamePart !== "subscriptions" &&
			lastPathnamePart !== "users" &&
			lastPathnamePart !== "support" &&
			lastPathnamePart !== "partners" &&
			lastPathnamePart !== "terminals" &&
			lastPathnamePart !== "products" &&
			lastPathnamePart !== "invoices"
		);
	};

	return (
		<div className="col-lg-8">
			<Form.Group className="form-group" style={{ marginBottom: "12px" }}>
				{getCardTypes().map((type, index) => {
					if (isApplicationsView() && type === "APPLICATIONS") {
						return (
							<Link key={index} to={url} className={"btn btn-outline-primary mb-1"}>
								{t(`enums.organization.card_type.APPLICATIONS`)}
							</Link>
						);
					}
					return (
						<Link
							key={index}
							className={`btn ${
								getLastPathnamePart() === type.toLowerCase()
									? "btn-outline-primary mb-1"
									: "btn-default mb-1"
							}`}
							to={`${url}${type !== "APPLICATIONS" ? `/${type.toLowerCase()}` : ""}`}
						>
							{t(`enums.organization.card_type.${type}`)}
						</Link>
					);
				})}
			</Form.Group>
			<OrganizationPreviewRoutes
				areAllowed={areAllowed}
				organization={organization}
				url={url}
				loading={loading}
				partners={partners}
				refresh={refresh}
				requests={requests}
				conversations={conversations}
				products={products}
				loadingProducts={loadingProducts}
				context={context}
			/>
		</div>
	);
};

export default OrganizationPreviewTabNavigation;
